import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import PublicProfile from './PublicProfile';

export default function PreviewProfile(): JSX.Element {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  // Utilise le même composant que le profil public
  // mais avec un paramètre spécial pour la prévisualisation
  return <PublicProfile preview={true} />;
}
